import React from 'react';
import { CoverageDetailsType } from '../types/CoberturaType';
import { useApp } from '../contexts/AppContext';

// Mapeamento de ícones com base nos nomes dos benefícios
const ICON_MAP: Record<string, string> = {
  'Telemedicina': 'fas fa-user-md',
  'Descontos em Farmácia': 'fas fa-pills',
  'Agenda Pessoal Digital': 'fas fa-calendar-alt',
  'Rede de Apoio Emocional': 'fas fa-hands-helping',
  'Televeterinário': 'fas fa-paw',
  'Consulta com Especialistas': 'fas fa-user-nurse',
  'Concierge': 'fas fa-concierge-bell',
  'Suporte Tecnológico para Dispositivos Digitais': 'fas fa-laptop',
  'Suporte Tecnológico para Automação Residencial': 'fas fa-home',
  'Assistência Residencial': 'fas fa-tools',
  'Gestão e Educação em Cybersegurança': 'fas fa-shield-alt',
  'Suporte com Especialistas em Cybersegurança': 'fas fa-user-shield',
  'Assistência Funeral': 'fas fa-cross',
  'Gestão de Ativos Digitais': 'fas fa-digital-tachograph',
  'Planejamento Sucessório e Testamentos': 'fas fa-file-signature',
  'Cuidados com o Pet': 'fas fa-dog',
  'Suporte Online': 'fas fa-headset',
  'Treinamentos Online': 'fas fa-chalkboard-teacher',
  'Sugestões e Atualizações Tecnológicas': 'fas fa-lightbulb',
  'Serviço de Transporte Especializado': 'fas fa-car',
};

type Props = {
  coverage: CoverageDetailsType;
};

export const Coverage: React.FC<Props> = ({ coverage }) => {
  const { setIsPrivacyOpen, setCoverage } = useApp();

  const handleCoverageClick = () => {
    setCoverage(coverage);
    setIsPrivacyOpen(true);
  };

  const iconClass = ICON_MAP[coverage.benefitName] || 'fas fa-question-circle';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start', // Alinhamento no início
        cursor: 'pointer',
        textAlign: 'center',
        padding: 8,
        width: '110px', // Controle da largura para melhor proporção
      }}
      onClick={handleCoverageClick}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '3a4f90',
          borderRadius: 10,
          width: 70,
          height: 70,
          boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)',
          marginBottom: 8,
        }}
      >
        <i
          className={iconClass}
          style={{
            color: '#3a4f90',
            fontSize: '32px',
          }}
        ></i>
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: '400',
          color: '#131e48',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
          textAlign: 'center',
          lineHeight: '1.2em',
        }}
      >
        {coverage.benefitName}
      </div>
    </div>
  );
};
